import { useCallback, useEffect, useState } from 'react';
import Project from 'src/entities/project';
import useSnackbarSystem from '@ui/systems/useSnackbarSystem';
import useUpdateProjectPermissionsMutation from '@projects/queries/useUpdateProjectPermissionsMutation';

const useReviewerR0Upload = ( { project }: { project: Project } ) => {
	const snackbarSystem = useSnackbarSystem();
	const [ reviewerR0UploadEnabled, setReviewerR0UploadEnabled ] = useState( project.reviewerR0UploadEnabled );

	useEffect( () => {
		setReviewerR0UploadEnabled( project.reviewerR0UploadEnabled );
	}, [ project.reviewerR0UploadEnabled ] );
	const { mutate: updateProjectPermissions } = useUpdateProjectPermissionsMutation( { projectID: project.id } );

	const updateReviewerR0Upload = useCallback( ( enabled: boolean ) => (
		updateProjectPermissions(
			{ reviewer_r0_upload_enabled: enabled },
			{
				onSuccess: ( _, { reviewer_r0_upload_enabled } ) => {
					snackbarSystem.showSuccessMessage( {
						title: reviewer_r0_upload_enabled
							? 'Reviewers can now upload new assets'
							: 'Asset upload disabled for reviewers'
					} );
				}
			}
		)
	), [ updateProjectPermissions, snackbarSystem ] );

	const onReviewerR0UploadChange = useCallback( () => {
		const enabled = !reviewerR0UploadEnabled;
		setReviewerR0UploadEnabled( enabled );
		updateReviewerR0Upload( enabled );
	}, [ reviewerR0UploadEnabled, updateReviewerR0Upload ] );

	return { reviewerR0UploadEnabled, onReviewerR0UploadChange };
};

export default useReviewerR0Upload;
